//Frontend Side
import {lockBody, unLockBody} from '@js_modules/functions';

document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector('header');
    if (!header) return;

    //Burger menu
    (function () {
        const burgerMenuButton = header.querySelector('.burger-menu');

        burgerMenuButton.addEventListener('click', function () {
            if (!document.documentElement.classList.contains('menu-open')) {
                openBurgerMenu();
            } else {
                closeBurgerMenu();
            }
        });

        //window is change
        (function () {
            const mediaQuery = window.matchMedia("(min-width: 992px)");

            function doThisCode() {
                if (mediaQuery.matches) {
                    //Desktop
                    if (header.classList.contains('menu-open')) {
                        closeBurgerMenu();
                    }
                }
            }

            //Window size is change
            if (mediaQuery.addEventListener) {
                mediaQuery.addEventListener("change", doThisCode);
            } else if (mediaQuery.addListener) mediaQuery.addListener(doThisCode);
        })();

        function openBurgerMenu() {
            document.documentElement.classList.toggle("menu-open");
            lockBody();
        }

        function closeBurgerMenu() {
            document.documentElement.classList.remove("menu-open");
            unLockBody();
        }
    })();

    //change button position
    (function () {
        const menuBody = header.querySelector('.menu__body');
        const button = header.querySelector('[data-move-to-burger-menu]');
        const firstParent = header.querySelector('.menu__actions');
        if (!menuBody || !button) return;

        const mediaQuery = window.matchMedia("(max-width: 992px)");

        function windowSizeIsChange() {
            if (mediaQuery.matches) {
                //mobile
                menuBody.appendChild(button)
            } else {
                //desktop
                const children = firstParent.children;
                firstParent.insertBefore(button, children[children.length - 1]);
            }
        }

        windowSizeIsChange();

        //===== window size is change ======
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', () => windowSizeIsChange());
        } else if (mediaQuery.addListener) {
            mediaQuery.addListener(() => windowSizeIsChange());
        }
    })();

    //scroll page
    (function (){
        const headerShow = header.hasAttribute('data-scroll-show');
        const headerShowTimer = header.dataset.scrollShow ? header.dataset.scrollShow : 500;
        const startPoint = header.dataset.scroll ? header.dataset.scroll : 1;
        let scrollDirection = 0;
        let timer;
        document.addEventListener("scroll", function (e){
            const scrollTop = window.scrollY;
            clearTimeout(timer);
            if (scrollTop >= startPoint) {
                !header.classList.contains('_header-scroll') ? header.classList.add('_header-scroll') : null;
                if (headerShow) {
                    if (scrollTop > scrollDirection) {
                        // downscroll code
                        header.classList.contains('_header-show') ? header.classList.remove('_header-show') : null;
                    } else {
                        // upscroll code
                        !header.classList.contains('_header-show') ? header.classList.add('_header-show') : null;
                    }
                    timer = setTimeout(() => {
                        !header.classList.contains('_header-show') ? header.classList.add('_header-show') : null;
                    }, headerShowTimer);
                }
            } else {
                header.classList.contains('_header-scroll') ? header.classList.remove('_header-scroll') : null;
                if (headerShow) {
                    header.classList.contains('_header-show') ? header.classList.remove('_header-show') : null;
                }
            }
            scrollDirection = scrollTop <= 0 ? 0 : scrollTop;
        })
    })();
});
